import { render, staticRenderFns } from "./RecommendedTag.vue?vue&type=template&id=b1799c3a&scoped=true&"
import script from "./RecommendedTag.vue?vue&type=script&lang=js&"
export * from "./RecommendedTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1799c3a",
  null
  
)

export default component.exports